var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvailableForPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#6FB24B",
    stroke: "#6FB24B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3842 8.97271L15.7516 8.24678L10.5976 10.6698V12.2257L9.69851 11.8259V10.27L14.8525 7.84702L13.1214 7.07729C12.8896 6.97424 12.5103 6.97424 12.2785 7.07729L8.01573 8.97271C7.67614 9.12371 7.399 9.55133 7.39986 9.92298L7.40651 12.7316C7.67373 12.6456 7.95804 12.5981 8.25347 12.5981C9.78188 12.5981 11.0255 13.8417 11.0255 15.3703C11.0255 15.7695 10.939 16.1484 10.7864 16.4916L12.2915 17.1351C12.5158 17.2309 12.8826 17.2309 13.1069 17.1351L17.3599 15.3176C17.7053 15.17 17.9886 14.742 17.9895 14.3664L18 9.92296C18.0009 9.55131 17.7237 9.12369 17.3842 8.97271ZM8.25343 13.1168C7.0089 13.1168 6 14.1257 6 15.3703C6 16.6148 7.0089 17.6237 8.25343 17.6237C9.49796 17.6237 10.5069 16.6148 10.5069 15.3703C10.5069 14.1257 9.49796 13.1168 8.25343 13.1168ZM9.7259 14.9073L8.33916 16.4673C8.27084 16.5442 8.17572 16.5837 8.07992 16.5837C8.00382 16.5837 7.92731 16.5588 7.86349 16.5076L6.99678 15.8143C6.84729 15.6948 6.82302 15.4766 6.94269 15.3271C7.0622 15.1775 7.28049 15.1533 7.42996 15.2729L8.03963 15.7606L9.20774 14.4465C9.33478 14.3035 9.554 14.2904 9.69712 14.4177C9.84025 14.5451 9.85312 14.7641 9.7259 14.9073Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableForPickup);
export default __webpack_public_path__ + "static/media/available_for_pickup.c172ab0f.svg";
export { ForwardRef as ReactComponent };